var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFleetSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2588 14.7778V9.2222H11.0736V11.0741H6.44394V7.37035H8.29579V2.74072H2.74023V7.37035H4.59209V19.4074H11.0736V21.2592H21.2588V15.7037H11.0736V17.5555H6.44394V12.9259H11.0736V14.7778H21.2588Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetSetup);
export default __webpack_public_path__ + "static/media/fleet_setup.d48c5209f762c94826a812a6f6d4ee7d.svg";
export { ForwardRef as ReactComponent };